import { SYSTEMS } from '../../constants/systems';
import { isProgramReady, isRunning, programImage } from './machineCardFacts';
import {
  DisplayIndicator,
  DisplayLogoImg,
  DisplayStateWrapper,
  SectionState,
} from './statusStyles';

/** One light per program the system offers, in the control-box order. */
const StatusLights = ({ system, device }) => {
  const { isOff } = device;
  return (
    <SectionState isOff={isOff}>
      {SYSTEMS[system].programs.map((program) => (
        <DisplayStateWrapper key={program} isOff={isOff}>
          <DisplayLogoImg src={programImage(program, isOff)} />
          <DisplayIndicator
            isActivated={isRunning(device, program)}
            isReady={isProgramReady(device, program)}
            isOff={isOff}
          />
        </DisplayStateWrapper>
      ))}
    </SectionState>
  );
};

export default StatusLights;
